import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CoreApiInterface } from './core-api.interface';


@Injectable({
 providedIn: 'root',
})
export class CoreApiService implements CoreApiInterface {

    constructor(private http: HttpClient) {}

    /**
     * Performs a request with `get` http method.
     */
    public get(url: string, options?: any): Observable<any> {
        return this.http.get<any>(url, options);
    }

    /**
     * Performs a request with `post` http method.
     */
    public post(url: string, body: any, options?: any): Observable<any> {
        return this.http.post<any>(url, body, options);
    }

    /**
     * Performs a request with `put` http method.
     */
    public put(url: string, body: any, options?: any): Observable<any> {
        return this.http.put<any>(url, body, options);
    }

    /**
     * Performs a request with `delete` http method.
     */
    public delete(url: string, options?: any): Observable<any> {
        return this.http.delete<any>(url, options);
    }

    /**
     * Performs a request with `patch` http method.
     */
    public patch(url: string, body: any, options?: any): Observable<any> {
        return this.http.patch<any>(url, body, options);
    }

    /**
     * Performs a request with `head` http method.
     */
    public head(url: string, options?: any): Observable<any> {
        return this.http.head<any>(url, options);
    }

    public isJson(str: string): boolean {
      try {
        JSON.parse(str);
        return true;
      } catch (e) {
        return false;
      }
    }

}
